
define('template!modalView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="body-region"></div>\n<div class="footer-region"></div>';

}
return __p
};});

